module.exports = __webpack_public_path__ + "static/media/gal0006.b1789f2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/gal00/gal0006.jpg
// module id = 389
// module chunks = 0